import React, { useContext, useEffect } from 'react';
import { KibNoteIcon, KibHeartFillIcon } from '@chewy/kib-icons-react';
// import { KibPharmacyIcon } from '@chewy/kib-icons-react';  /*** PRESCRIPTION WORK TBD ***/
import KibDivider from '@chewy/kib-divider-react';
import { PetInterface } from 'types/pet';
import AnalyticsContext from '../../context/AnalyticsContext';
import { isPIIInfo } from '../../components/pet-profile-details/PetProfileDetails';
import { PII_CLASSNAME } from '../../util/helpers';
import { getMemorialDetails } from './utils/memorial-detail-helper';
import './memorial-details.scss';
// import PrescriptionCard from './PrescriptionCard';  /*** PRESCRIPTION WORK TBD ***/

export default function MemorialDetails({ petProfile }: { petProfile: PetInterface }) {
  const [basicFields, healthFields] = getMemorialDetails(petProfile);

  const healthHeader = 'Health';
  const basicsHeader = 'Basics';

  const analytics = useContext(AnalyticsContext);

  /*** PRESCRIPTION WORK TBD ***/
  // const prescriptionsHeader = 'Prescriptions';
  // const prescriptionsSubheader = 'Purchased through Chewy';

  // /* START MOCK DATA */
  // const brandName = 'NexGard';
  // const description = '10.1-24 lbs, (Purple Box)';
  // const prescriber = 'World of ANimations at South Philadelphia';
  // const productImg =
  //   'https://cdn.royalcanin-weshare-online.io/fufPTYcBaPOZra8qQPwH/v51/00030111447142-cf-gs1.jpg';

  // const mockPrescriptionCards = [
  //   {
  //     brandName: brandName,
  //     description: description,
  //     prescriber: prescriber,
  //     productPhoto: productImg,
  //   },
  //   {
  //     brandName: brandName,
  //     description:
  //       description +
  //       description +
  //       description +
  //       description +
  //       description +
  //       description +
  //       description +
  //       description,
  //     prescriber: prescriber,
  //     productPhoto: productImg,
  //   },
  //   {
  //     brandName: brandName,
  //     description: description,
  //     prescriber: prescriber,
  //     productPhoto: productImg,
  //   },
  //   {
  //     brandName: brandName,
  //     description: description,
  //     prescriber: prescriber,
  //     productPhoto: productImg,
  //   },
  // ];
  // /* END MOCK DATA */

  useEffect(() => {
    analytics.trackRainbow({
      name: 'pet profile memorial - viewed',
      category: 'pet-profile-memorial',
      action: 'impression',
      label: 'pet_profile_memorial_details_impression',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderLabelAndValue = (label: string, value?: string | number | null) => (
    <div className="memorial-details__item" data-testid={`memorial-detail-${label}`}>
      <h3 className="memorial-details__title" data-testid={`memorial-detail-dt-${label}`}>
        {label}
      </h3>
      <div className="memorial-details__detail" data-testid={`memorial-detail-dd-${label}`}>
        {value}
      </div>
      <KibDivider className="memorial-details__divider" />
    </div>
  );

  const hasNoHealthDetails = healthFields.every((item) => item.value === '' || item.value === null);
  const hasNoBasicDetails = basicFields.every((item) => item.value === '' || item.value === null);

  return (
    <div className="memorial-details">
      {!hasNoHealthDetails && (
        <>
          <h3
            className="memorial-details__section-header"
            data-testid="memorial-detail-section-health"
          >
            <KibHeartFillIcon className="memorial-details__section-header--icon" />
            {healthHeader}
          </h3>
          {healthFields.map(({ label, value }) => (
            <React.Fragment key={`${label}${value}`}>
              {!!value && (
                // eslint-disable-next-line react/jsx-no-useless-fragment
                <>
                  {isPIIInfo(label) ? (
                    <div className={PII_CLASSNAME} data-hj-suppress data-testid="pii-hotjar">
                      {renderLabelAndValue(label, value)}
                    </div>
                  ) : (
                    renderLabelAndValue(label, value)
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </>
      )}
      {/* <h3
        className="memorial-details__section-header"
        data-testid="memorial-detail-section-prescriptions"
      >
        <KibPharmacyIcon className="memorial-details__section-header--icon" />
        {prescriptionsHeader}
      </h3>
      <div className="memorial-details__section-subheader">{prescriptionsSubheader}</div>
      <div className="prescriptions-container">
        {mockPrescriptionCards.map((card, index) => (
          <PrescriptionCard card={card} key={index} />
        ))}
      </div> */}
      {!hasNoBasicDetails && (
        <>
          <h3
            className="memorial-details__section-header"
            data-testid="memorial-detail-section-basics"
          >
            <KibNoteIcon className="memorial-details__section-header--icon" />
            {basicsHeader}
          </h3>
          {basicFields.map(({ label, value }) => (
            <React.Fragment key={`${label}${value}`}>
              {!!value && renderLabelAndValue(label, value)}
            </React.Fragment>
          ))}
        </>
      )}
    </div>
  );
}
